var _desc, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRankingPeopleFirst(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Ranking-People-First--Streamline-Ultimate.svg",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Ranking People First Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.25 17.25h-6c-0.39782 0 -0.77936 0.158 -1.06066 0.4393C0.908035 17.9706 0.75 18.3522 0.75 18.75v4.5h7.5v-6Z",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21.75 17.25h-6v6h7.5v-4.5c0 -0.3978 -0.158 -0.7794 -0.4393 -1.0607s-0.6629 -0.4393 -1.0607 -0.4393Z",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.25 11.25h-4.5c-0.39782 0 -0.77936 0.158 -1.06066 0.4393 -0.2813 0.2813 -0.43934 0.6629 -0.43934 1.0607v10.5h7.5v-10.5c0 -0.3978 -0.158 -0.7794 -0.4393 -1.0607s-0.6629 -0.4393 -1.0607 -0.4393Z",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.375 3.375c0 0.69619 0.27656 1.36387 0.7688 1.85616C10.6361 5.72344 11.3038 6 12 6c0.6962 0 1.3639 -0.27656 1.8562 -0.76884 0.4922 -0.49229 0.7688 -1.15997 0.7688 -1.85616 0 -0.69619 -0.2766 -1.36387 -0.7688 -1.85616C13.3639 1.02656 12.6962 0.75 12 0.75c-0.6962 0 -1.3639 0.27656 -1.8562 0.76884 -0.49224 0.49229 -0.7688 1.15997 -0.7688 1.85616Z",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.249 8.25002c-0.4007 -0.47055 -0.8989 -0.84847 -1.46 -1.10762 -0.5612 -0.25916 -1.1719 -0.39338 -1.79 -0.39338 -0.6181 0 -1.2288 0.13422 -1.7899 0.39338 -0.56114 0.25915 -1.05931 0.63707 -1.46008 1.10762",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.376 10.125c0 0.6962 0.2765 1.3639 0.7688 1.8562 0.4923 0.4922 1.16 0.7688 1.8562 0.7688 0.6962 0 1.3638 -0.2766 1.8561 -0.7688 0.4923 -0.4923 0.7689 -1.16 0.7689 -1.8562 0 -0.69619 -0.2766 -1.36387 -0.7689 -1.85616C21.3648 7.77656 20.6972 7.5 20.001 7.5c-0.6962 0 -1.3639 0.27656 -1.8562 0.76884 -0.4923 0.49229 -0.7688 1.15997 -0.7688 1.85616Z",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M23.25 15c-0.5397 -0.6345 -1.2537 -1.097 -2.0535 -1.33 -0.7998 -0.233 -1.6504 -0.2264 -2.4465 0.019",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1.37402 10.125c0 0.6962 0.27657 1.3639 0.76885 1.8562 0.49228 0.4922 1.15996 0.7688 1.85615 0.7688 0.6962 0 1.36388 -0.2766 1.85616 -0.7688 0.49228 -0.4923 0.76884 -1.16 0.76884 -1.8562 0 -0.69619 -0.27656 -1.36387 -0.76884 -1.85616C5.3629 7.77656 4.69522 7.5 3.99902 7.5c-0.69619 0 -1.36387 0.27656 -1.85615 0.76884 -0.49228 0.49229 -0.76885 1.15997 -0.76885 1.85616Z",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0.75 15c0.4016 -0.4695 0.89995 -0.8466 1.46091 -1.1055C2.77187 13.6356 3.38218 13.501 4 13.5c0.42205 0.0003 0.84168 0.0637 1.245 0.188",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankingPeopleFirst);
export default __webpack_public_path__ + "static/media/Ranking-People-First.32e897ec3ef9224fd696ab3040061a58.svg";
export { ForwardRef as ReactComponent };